// Week navigation control overlaid on the dashboard bar chart.
import { IconButton } from '@mui/material';
import { alpha, useTheme } from '@mui/material/styles';

const NAV_BUTTON_BG_OPACITY = 0.92;

const ChartNavButton = ({ visible, onClick, label, side, children }) => {
  const theme = useTheme();
  if (!visible) return null;

  return (
    <IconButton
      size="small"
      type="button"
      onClick={onClick}
      aria-label={label}
      sx={{
        position: 'absolute',
        top: '50%',
        [side]: 4,
        transform: 'translateY(-50%)',
        zIndex: 1,
        bgcolor: alpha(theme.palette.background.paper, NAV_BUTTON_BG_OPACITY),
        border: 1,
        borderColor: 'divider',
        boxShadow: 1,
        '&:hover': {
          bgcolor: 'background.paper',
        },
      }}
    >
      {children}
    </IconButton>
  );
};

export default ChartNavButton;
